import { useContent } from "@/i18n/content";

export default function Marquee() {
  const { MARQUEE_ITEMS } = useContent();
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section
      className="relative bg-[#F4F3EF] py-3 overflow-hidden border-y border-black/5"
      data-testid="marquee"
      style={{
        WebkitMaskImage: "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
        maskImage: "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
      }}
    >
      <div className="marquee-track group hover:[animation-play-state:paused]">
        {items.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-semibold uppercase tracking-[0.16em] text-slate-500 text-[11px] sm:text-xs px-5">
              {item}
            </span>
            <span className="w-1 h-1 rounded-full bg-emerald-500/60" />
          </div>
        ))}
      </div>
    </section>
  );
}
